import UAParser from 'ua-parser-js'

export function isMobileUserAgent(): boolean {
  const parser = new UAParser()
  const result = parser.getResult()
  const deviceType = result.device.type

  return deviceType === 'mobile'
}
